import { serialize } from '../../common/components/utils/utils';

let googleMapsScriptIsInjected = false;

function injectGoogleMapsApiScript(options = {}) {
	if (googleMapsScriptIsInjected) {
		return;
	}

	const optionsQuery = serialize(options);

	const url = `https://maps.googleapis.com/maps/api/js?${optionsQuery}`;

	const script = document.createElement('script');

	script.setAttribute('src', url);
	// This is not needed as the script loads at the bottom of the page.
	// Left intentionally for future reference.
	// script.setAttribute('async', '');
	// script.setAttribute('defer', '');

	document.body.appendChild(script);

	googleMapsScriptIsInjected = true;
}

function loadGoogleMapsApi(options = {}) {
	injectGoogleMapsApiScript({
		key: window.GOOGLE_MAPS_API_KEY,
		language: document.head.parentElement.getAttribute('lang'),
		callback: 'initMap',
		...options,
	});
}

export default loadGoogleMapsApi;
